"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var modal_1 = __importDefault(require("../../../plugins/modal"));
var SizeChartModalApp = /** @class */ (function (_super) {
    __extends(SizeChartModalApp, _super);
    function SizeChartModalApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: false,
        };
        _this.showModal = function () {
            _this.setState({ open: !_this.state.open });
        };
        _this.closeModal = function () {
            _this.setState({ open: false });
        };
        return _this;
    }
    SizeChartModalApp.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("a", { className: this.props.linkClassName || 'text-underline h7 text-white', onClick: this.showModal }, this.props.text),
            React.createElement(modal_1.default, { isOpen: this.state.open, handleClose: this.closeModal },
                React.createElement("img", { src: this.props.url, className: 'show-for-medium' }),
                React.createElement("img", { src: this.props.urlMobile || this.props.url, className: 'show-for-small-only' }))));
    };
    return SizeChartModalApp;
}(React.Component));
exports.default = SizeChartModalApp;
